import { render, staticRenderFns } from "./BlackoutsList.vue?vue&type=template&id=24b94765&scoped=true&"
import script from "./BlackoutsList.vue?vue&type=script&lang=js&"
export * from "./BlackoutsList.vue?vue&type=script&lang=js&"
import style0 from "./BlackoutsList.vue?vue&type=style&index=0&id=24b94765&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b94765",
  null
  
)

export default component.exports